import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	footer: {
		background: theme.palette.background.footer,
		marginTop: "auto",
		position: "relative",
		zIndex: 1
	},
	wrapper: {
		padding: theme.spacing(5, 0),
		position: "relative",
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(10, 0, 5)
		}
	},
	container: {
		paddingBottom: theme.spacing(5),
		paddingTop: theme.spacing(10),
		[theme.breakpoints.up("md")]: {
			paddingBottom: theme.spacing(10),
			paddingTop: theme.spacing(10)
		}
	},
	top: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(5),
		justifyContent: "space-between",
		paddingBottom: theme.spacing(19.5),
		position: "relative",
		"&:after": {
			backgroundImage: "url('/img/footer-mountains.svg')",
			backgroundSize: "contain",
			backgroundRepeat: "no-repeat",
			bottom: 40,
			content: "''",
			height: 76,
			left: "50%",
			transform: "translate(-50%,0)",
			position: "absolute",
			pointerEvents: "none",
			width: "100%",
			zIndex: -1,
			[theme.breakpoints.up("md")]: {
				bottom: 0,
				height: 156,
				left: -62,
				transform: "unset"
			}
		},
		[theme.breakpoints.up("md")]: {
			display: "grid",
			rowGap: theme.spacing(0),
			columnGap: theme.spacing(10),
			gridTemplateColumns: "1fr 535px",
			gridTemplateRows: "auto",
			paddingBottom: theme.spacing(4)
		},
		[theme.breakpoints.up("lg")]: {
			gridTemplateColumns: "400px 535px 1fr"
		}
	},
	bottom: {
		alignItems: "center",
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(3),
		justifyContent: "space-between",
		[theme.breakpoints.up("md")]: {
			flexDirection: "row-reverse"
		}
	}
}));

export default styles;
